import "animate.css";
import Swal from 'sweetalert2'

export const Contact = () => {
  
  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "47c17622-ba22-4678-98b8-1a598b4209e9");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: json
    }).then((res) => res.json());

    if (res.success) {
      Swal.fire({
        title: "Success!",
        text: "Message sent successfully!",
        icon: "success"
      });
    }
    else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  return (
    <section className="contact" id="connect">
      <form onSubmit={onSubmit}>
        <h2>Send me a message</h2>
        <div className="input-box">
          <input type="text" className="field"  placeholder="Full name" name="name" required />
          <input type="email" className="field" placeholder="Email" name="email" required />
          <textarea name="message" id="" className="field mess" placeholder="Your message" required></textarea>
        </div>
        <button type="submit">Send</button>
      </form>
    </section>
  );
};
